import Vue from "vue";
import Vuex from "vuex";
import Service from "../../../service/api.js";
import router from "../../../router/index.js";
import store from "@/store/store";

const ServerModule = {
    namespaced: true,
    state: {
        login : "",
        content : {
            _id:null,
            startDate : "",
            emdDate : "",
            title : [{key:"th", value:""},{key:"en", value:""}],
            subTitle : [{key:"th", value:""},{key:"en", value:""}],
            description : [{key:"th", value:""},{key:"en", value:""}],

            message : ""
        },
        item : []
    },

    mutations: {
        item(state, obj) {
            state.item = obj;
        },
        content(state, obj) {
            state.content = obj;
        }
    },

    actions: {
        configLogin({commit}, data) {
            return Service.login('get', {}, {})
                .then((response) => {
                    store.commit("config/item", response.data.data)
                    return response
                }).catch((err) => {
            });
        },
        createLogin({commit}, data) {
            store.commit("dialog/loading", true)
            return Service.login('post', {...data}, {})
                .then((response) => {
                    store.commit("dialog/loading", false)
                    store.commit("dialog/toasts", 1)
                    return store.dispatch("config/configLogin").then(() => response)
                }).catch((err) => {
                    store.commit("dialog/loading", false)
            });
        },
        updateLogin({commit}, data) {
            store.commit("dialog/loading", true)
            return Service.login('put', data, {})
                .then((response) => {
                    store.commit("dialog/loading", false)
                    store.commit("dialog/toasts", 1)
                    return store.dispatch("config/configLogin").then(() => response)
                }).catch((err) => {
                    store.commit("dialog/loading", false)
            });
        }

    },

    getters: {
        item(state, obj) {
            return state.item;
        },
        content(state, obj) {
            return state.content;
        }
    },
};

export default ServerModule;
